module.exports = __webpack_public_path__ + "img/slider_banner_1.b8895fa3.jpg";